import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "relative inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all duration-150 ease-flowy focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 disabled:translate-y-0 disabled:shadow-none [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 [&_svg]:drop-shadow-[0_1px_0_rgba(255,255,255,0.25)]",
  {
    variants: {
      variant: {
        default:
          "bg-gradient-to-b from-[hsl(221_60%_42%)] to-[hsl(221_63%_32%)] text-primary-foreground border border-[hsl(221_63%_24%)] shadow-raised hover:from-[hsl(221_63%_46%)] hover:to-[hsl(221_63%_35%)] hover:-translate-y-0.5 active:translate-y-0 active:shadow-pressed active:from-[hsl(221_63%_30%)] active:to-[hsl(221_63%_30%)]",
        destructive:
          "bg-gradient-to-b from-[hsl(0_75%_58%)] to-[hsl(0_70%_46%)] text-destructive-foreground border border-[hsl(0_65%_36%)] shadow-raised hover:from-[hsl(0_75%_62%)] hover:to-[hsl(0_70%_50%)] hover:-translate-y-0.5 active:translate-y-0 active:shadow-pressed",
        outline:
          "skeu-panel hover:-translate-y-0.5 hover:shadow-raised active:translate-y-0 active:shadow-pressed active:bg-none",
        secondary:
          "bg-gradient-to-b from-white to-[hsl(210_20%_93%)] text-secondary-foreground border border-[hsl(214_25%_82%)] shadow-raised-sm hover:-translate-y-0.5 hover:shadow-raised active:translate-y-0 active:shadow-pressed",
        ghost: "hover:bg-accent hover:text-accent-foreground active:shadow-pressed active:bg-black/5",
        link: "text-primary underline-offset-4 hover:underline",
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 rounded-md px-3 text-xs",
        lg: "h-10 rounded-md px-8",
        icon: "h-9 w-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
